module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BlackIt.195a18c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BlackIt.svg
// module id = 345
// module chunks = 3